import { useGoodsSno } from '../../../hooks/useGoodsSno';
import { useQuery } from '@tanstack/react-query';
import { goodsService } from 'shared/src/api';
import { queryKey } from '../../../constant/queryKey';
import { convertCodiGoodsItemToGoodsData } from '../utils/convertCodiGoodsItemToGoodsData';
import { isNil } from 'shared/src/utils';

export const useCodiGoodsList = () => {
  const goodsSno = useGoodsSno();

  return useQuery({
    queryKey: queryKey.goodsCodi(goodsSno),
    queryFn: () => goodsService.getCodiGoods(goodsSno),
    select: data => {
      if (isNil(data.codi_goods)) {
        return {
          ...data,
          codi_goods: null,
        };
      }
      return {
        ...data,
        codi_goods: {
          ...data.codi_goods,
          item_list: data.codi_goods.item_list.map(
            convertCodiGoodsItemToGoodsData,
          ),
        },
      };
    },
  });
};
